import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { AccordionDetails, AccordionSummary } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import React from 'react';

import { ServiceTitanAppointment, TimezoneAbbreviationEnum } from '_lib/api/apiTypes.shim';

import { Accordion } from '_lib/components/Accordion/Accordion';
import { Box } from '_lib/components/Box/Box';
import { Grid } from '_lib/components/Grid/Grid';
import { List } from '_lib/components/List/List';
import { Typography } from '_lib/components/Typography/Typography';
import { DateFormatEnum, DateUtils } from '_lib/utils/date.utils';

import { toSxArray } from '_lib/utils/helpers';

import { AppointmentDisplay } from './AppointmentDisplay';

export interface AppointmentListProps {
  appointments: ServiceTitanAppointment[];
  jobNo: string;
  timezone: TimezoneAbbreviationEnum;
  sx?: SxProps<Theme>;
}

export const AppointmentList = (props: AppointmentListProps): React.ReactElement => {
  const { appointments, jobNo, timezone, sx } = props;
  return (
    <List sx={[{ color: 'inherit', flexGrow: 1 }, ...toSxArray(sx)]}>
      {appointments?.map((appointment, index) => (
        <Accordion
          key={index}
          sx={{ pointerEvents: appointment.specialInstructions ? 'all' : 'none' }}
          disableGutters
          variant='outlined'>
          <AccordionSummary expandIcon={appointment.specialInstructions && <ExpandMoreIcon />}>
            <Grid container spacing={1} sx={{ alignItems: 'center' }}>
              <Grid item xs={1} sm={1}>
                <Box sx={{ display: 'inline', paddingRight: 2 }}>
                  <PendingActionsIcon />
                </Box>
              </Grid>
              <Grid item xs={11} sm={11}>
                <AppointmentDisplay serviceTitanAppointment={appointment} jobNo={jobNo} timezone={timezone} />
                <Typography sx={{ display: 'inline' }} variant='body1Bold' text='modified: ' />
                <Typography
                  sx={{ display: 'inline' }}
                  text={DateUtils.format(appointment.providerModifiedAt, DateFormatEnum.DateAtTime, {
                    timezone,
                    showTimezone: true
                  })}
                />
              </Grid>
            </Grid>
          </AccordionSummary>
          {appointment.specialInstructions && (
            <AccordionDetails>
              <Typography sx={{ display: 'inline' }} variant='body1Bold' text='Special Instructions' />
              <Typography text={appointment.specialInstructions.trim()} sx={{ whiteSpace: 'pre-wrap' }} />
            </AccordionDetails>
          )}
        </Accordion>
      ))}
    </List>
  );
};
